var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.firstLoading,
          expression: "firstLoading",
        },
      ],
      staticClass: "yxt-biz yxtbiz-discuss-speech",
    },
    [
      _c("div", { staticClass: "yxtbiz-discuss-speech__head" }, [
        _c(
          "div",
          { staticClass: "yxtbiz-discuss-speech__head__left" },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("pc_biz_discuss_speech").d("讨论发言"))),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.total))]),
            _vm.speechDesignated
              ? _c(
                  "yxt-tooltip",
                  { attrs: { effect: "dark", placement: "top" } },
                  [
                    _c("template", { slot: "content" }, [
                      _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm
                                .$t("pc_biz_discuss_reply_tip")
                                .d("学员对他人发言的回复不计入在内")
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    _c("yxt-svg", {
                      staticClass:
                        "color-gray-6 hover-primary-6 ml4 cursor-pointer",
                      attrs: {
                        width: "16px",
                        height: "16px",
                        "icon-class": "question-cirlce-o",
                      },
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
        _vm.discussVisible || _vm.isPreview || _vm.hasCompleted
          ? _c(
              "div",
              { staticClass: "yxtbiz-discuss-speech__head__right" },
              [
                _c(
                  "yxt-dropdown",
                  {
                    attrs: { trigger: "click" },
                    on: { command: _vm.orderByChange },
                  },
                  [
                    _c("span", { staticClass: "color-59" }, [
                      _vm._v(_vm._s(_vm.currentOrderBy.name)),
                    ]),
                    _c(
                      "yxt-dropdown-menu",
                      {
                        attrs: {
                          slot: "dropdown",
                          "max-height": "300",
                          "max-width": "300",
                        },
                        slot: "dropdown",
                      },
                      _vm._l(_vm.orderByList, function (item, index) {
                        return _c(
                          "yxt-dropdown-item",
                          {
                            key: index,
                            class: [
                              _vm.currentOrderBy.command === item.command
                                ? "yxt-dropdown-current-item"
                                : "",
                            ],
                            attrs: { command: item },
                          },
                          [_vm._v(_vm._s(item.name))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm.discussVisible || _vm.isPreview || _vm.hasCompleted
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "infinite-scroll",
                  rawName: "v-infinite-scroll",
                  value: _vm.getComments,
                  expression: "getComments",
                },
              ],
              attrs: {
                "infinite-scroll-disabled": "disabled",
                "infinite-scroll-immediate": false,
              },
            },
            [
              _vm._l(_vm.comments, function (comment) {
                return _c(
                  "Speech",
                  _vm._b(
                    {
                      key: comment.id,
                      attrs: {
                        data: comment,
                        "allow-anonymous": _vm.allowAnonymous,
                        "board-id": _vm.boardId,
                        orderby: _vm.orderby,
                        ccConfig: _vm.ccConfig,
                      },
                      on: {
                        "on-delete": _vm.onSpeechDelete,
                        "on-replay": _vm.onSpeechReplay,
                      },
                    },
                    "Speech",
                    _vm.$props,
                    false
                  )
                )
              }),
              _vm.loading
                ? _c("div", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticClass: "yxtbiz-discuss-speech__loading__space",
                    attrs: {
                      "yxt-loading-custom-class":
                        "yxtbiz-discuss-speech__loading",
                      "yxt-loading-size": "small",
                      "yxt-loading-text": _vm.$t("pc_biz_ai_loadding"),
                    },
                  })
                : _vm._e(),
              _vm.noMore
                ? _c("div", { staticClass: "yxtbiz-discuss-speech__no-more" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("pc_biz_tip_no_more").d("没有更多了")) +
                        "\n    "
                    ),
                  ])
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      !_vm.isPreview
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.discussVisible && !_vm.hasCompleted,
                  expression: "!discussVisible && !hasCompleted",
                },
              ],
              staticClass: "yxtbiz-discuss-speech__show-more",
            },
            [
              _c(
                "span",
                {
                  staticClass: "hand",
                  on: {
                    click: function ($event) {
                      _vm.discussVisible = true
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm
                        .$t("pc_biz_discuss_view_other_speech")
                        .d("查看他人发言")
                    )
                  ),
                ]
              ),
              _c("yxt-svg", {
                staticClass: "hand",
                attrs: {
                  width: "16px",
                  height: "16px",
                  "icon-class": "arrow-down",
                },
                on: {
                  click: function ($event) {
                    _vm.discussVisible = true
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }